import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from './components/Layout';
import CompaniesPage from './pages/CompaniesPage';
import Index from "./pages/DashboardPage";
import ForgotPage from "./pages/ForgotPage";
import MyProfile from './pages/ProfilePage/index copy';
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';
import ResetPage from './pages/ResetPage';
import PermitsPage from "./pages/PermitsPage";

function App() {
    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path="/sign-in" element={<PublicRoute component={SignInPage} />} />
                    <Route path="/sign-up" element={<SignUpPage />} />
                    <Route path="/forgot-password" element={<PublicRoute component={ForgotPage} />} />
                    {/* <Route path="/verify-otp" element={<PublicRoute component={VerifyPage} />} /> */}
                    <Route path="/reset-password" element={<PublicRoute component={ResetPage} />} />

                    <Route path="/" element={<PrivateRoute component={Layout} />}>
                        <Route index element={<Index />} />

                        <Route path="/profile" element={<MyProfile />} />

                        <Route path="/companies" element={<CompaniesPage />} />


                        <Route path="/permits" element={<PermitsPage />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </>
    );
}

export default App;
